export default __webpack_public_path__ + "static/media/music-placeholder.730666f5.jpg";